module.exports = __webpack_public_path__ + "static/media/button-icon-left.0c56bd93.svg";